export default __webpack_public_path__ + "static/cat-3169e7dd79140f7ac591e6a30682df09.jpg";